// @ts-nocheck

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { Target } from '../client';
import GRMiddleware from '../modules/gift-race/middlewares/GRMiddleware';
import gridsMiddleware from '../modules/grids/middleware';
import immersiveActionsController from '../modules/immersive/middlewares/actionsController';
import MPMiddleware from '../modules/monopoly/middlewares/MPMiddleware';
import getRootReducer from '../reducers';

import basketActionsInterceptorMiddleware from './basketActionsInterceptorMiddleware';
import basketMiddleware from './basketMiddleware';
import cashoutMiddlewares from './cashoutMiddlewares';
import computeBetslipBonusMiddleware from './computeBetslipBonusMiddleware';
import computeComboBoosterMiddleware from './computeComboBoosterMiddleware';
import debounceActionMiddleware from './debounceActionMiddleware';
import historyMiddleware from './historyMiddleware';
import itemsMiddleware from './itemsMiddleware';
import myMatchMiddleware from './myMatchMiddleware';
import networkMiddleware from './networkMiddleware';
import onUserSetConnectedMiddleware from './onUserSetConnectedMiddleware';
import storageMiddleware from './storageMiddleware';
import synchronousMiddleware from './synchronousMiddleware';

export default (socket, history, initialState, options = {}) => {
  let store = null;
  const middlewares = applyMiddleware(
    basketActionsInterceptorMiddleware,
    thunk,
    debounceActionMiddleware,
    synchronousMiddleware({
      history,
      onExternalLinkOpen: options.onExternalLinkOpen,
    }),
    networkMiddleware(socket, history),
    cashoutMiddlewares, // ORDER IS IMPORTANT
    storageMiddleware,
    onUserSetConnectedMiddleware,
    computeComboBoosterMiddleware,
    computeBetslipBonusMiddleware,
    historyMiddleware,
    immersiveActionsController,
    gridsMiddleware,
    itemsMiddleware,
    basketMiddleware(history),
    myMatchMiddleware(history),
    MPMiddleware(history),
    GRMiddleware(history),
  );

  const rootReducer = getRootReducer(history);
  if (Target.__ENV__ !== 'production') {
    const composeEnhancers =
      typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ maxAge: 200, trace: true })
        : compose;
    store = createStore(rootReducer, initialState, composeEnhancers(middlewares));
  } else {
    store = createStore(rootReducer, initialState, compose(middlewares));
  }

  return store;
};
